import { render, staticRenderFns } from "./SelectCopy.vue?vue&type=template&id=64db2cda&"
import script from "./SelectCopy.vue?vue&type=script&lang=js&"
export * from "./SelectCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64db2cda')) {
      api.createRecord('64db2cda', component.options)
    } else {
      api.reload('64db2cda', component.options)
    }
    module.hot.accept("./SelectCopy.vue?vue&type=template&id=64db2cda&", function () {
      api.rerender('64db2cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/SelectCopy.vue"
export default component.exports